

































import {Component, Prop, Vue} from 'vue-property-decorator'
import {ID, Resp} from 'simpli-web-sdk'
import AlertaCarga from '@/model/resource/AlertaCarga'
import * as Helper from '@/helpers'

@Component
export default class ModalAlertAlertaCarga extends Vue {

  list: AlertaCarga[] = []

  get collection() {
    return Helper.collect(AlertaCarga, this.list)
  }

  close() {
    this.$modal.close('alertAlertaCarga')
  }

  async openEvent(ids: ID[]) {
    const promise = ids.slice(0, 10).map((id) => new AlertaCarga().find(id))

    const fetch = async () => {
      const responses = await Promise.all(promise)
      this.list = responses.map((resp: Resp<AlertaCarga>) => resp.data)
    }

    await this.$await.run(fetch, 'alertAlertaCarga')

    this.$emit('open')
  }

  closeEvent() {
    this.$emit('close')
  }
}
